import { useState, useRef, useCallback, useEffect } from "react";
import { LegacyVoiceOption as VoiceOption } from "@/constants/audioVoice";
import { VoicePreviewRef } from "@/components/voice/VoicePreview";

interface UseVoicePlayerReturn {
  isPlaying: boolean;
  progress: number;
  voicePreviewRef: React.RefObject<VoicePreviewRef>;
  handlePlayPause: () => void;
  handleProgress: (progress: number) => void;
  handlePlayStateChange: (isPlaying: boolean) => void;
}

export const useVoicePlayer = (
  voice: VoiceOption | null | undefined,
): UseVoicePlayerReturn => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const voicePreviewRef = useRef<VoicePreviewRef>(null);

  useEffect(() => {
    setIsPlaying(false);
    setProgress(0);
    voicePreviewRef.current?.pause();
  }, [voice?.value, voice?.audio]);

  const handlePlayPause = useCallback(() => {
    if (!voice) return;

    if (isPlaying) {
      voicePreviewRef.current?.pause();
    } else {
      voicePreviewRef.current?.play();
    }
  }, [voice, isPlaying]);

  const handleProgress = useCallback((newProgress: number) => {
    setProgress(newProgress);
  }, []);

  const handlePlayStateChange = useCallback((playing: boolean) => {
    setIsPlaying(playing);
  }, []);

  return {
    isPlaying,
    progress,
    voicePreviewRef,
    handlePlayPause,
    handleProgress,
    handlePlayStateChange,
  };
};
